import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WOW from "wowjs";

function WorkingProcess({ dataWorkingProcess }) {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);
  return (
    <div>
      <div className="tpm-services-process-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src="assets/images/services/section-custom-menubar.png"
                    alt="Corporate_service"
                  />
                  <span className="subtitle">
                    {dataWorkingProcess?.subTitle}
                  </span>
                </div>
                <h2 className="title split-collab">
                  {dataWorkingProcess?.title}
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-5">
            {dataWorkingProcess?.items.map((item) => {
              return (
                <div
                  key={item.id}
                  className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft"
                  data-wow-duration=".8s"
                  data-wow-delay={`.${item.id}s`}
                >
                  <div className="single-services">
                    <div className="services-inner">
                      <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                        <Link to="#">
                          <img src={item.img} alt={item.title} />
                        </Link>
                        <div className="number-bg-round">
                          <span>{item.id}</span>
                        </div>
                      </div>
                      <div className="services-content services-content-style-1 text-center">
                        <h5 className="title">{item.title}</h5>
                        <p className="description">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkingProcess;
